import React from 'react';

import AvatarGroup from '@atlaskit/avatar-group/avatar-group';

import { appearances } from '../../examples-util/appearances';
import { RANDOM_USERS } from '../../examples-util/random-users';

const data = RANDOM_USERS.map((d, i) => ({
	key: d.email,
	name: d.name,
	href: '#',
	appearance: appearances[i % appearances.length],
}));

const AvatarGroupBorderColorExample = (): React.JSX.Element => (
	<AvatarGroup data={data} borderColor="#FF6347" />
);

export default AvatarGroupBorderColorExample;
